import React from 'react';
import PropTypes from 'prop-types';
import * as shapes from '../../shapes';
import * as productsShapes from '../../../products/shapes';
import List from './List';

const ProductList = ({ products, selectedProducts, addItem }) => (
  <div>
    <h3 className="c-heading u-mb-">Products</h3>
    <List
      items={products}
      selectedItems={selectedProducts}
      addItem={addItem}
      color="blue"
      isProducts
    />
  </div>
  );
ProductList.propTypes = {
  products: productsShapes.products,
  selectedProducts: PropTypes.arrayOf(PropTypes.string),
  addItem: shapes.handler,
};
ProductList.defaultProps = {
  products: [],
  selectedProducts: [],
  addItem: () => null,
};

export default ProductList;
